module.exports = __webpack_public_path__ + "img/prone.5a70d5ee.svg";